import { Box, Container } from '@mui/material';
import TagManager from '@sooro-io/react-gtm-module';
import { quoteStyles } from '../../assets/styles/home';
import MetaTags from '../../components/MetaTags';
import Footer from '../../components/layout/Footer';
import Header from '../../components/layout/Header';
import InsuranceForm from '../../components/services/insurance/InsuranceForm';

export const defaultImageUrl =
  'https://aefinancialservicesllc.com/static/media/ae.378619c78bb33dfcfb8c.png';
export const primaryImageUrl =
  'https://imageupload.io/ib/9NZbCa0NJGHTFJJ_1699552355.png';

const Quote = () => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'pageview',
      pagePath: '/quote',
      pageTitle: 'Quote',
    },
  });
  return (
    <Box>
      <MetaTags
        title="A&E Financial Services - Quote. Read | taxes | processes"
        description="Discover A&E Financial Services, your trusted source for personalized insurance, read taxes, and financial solutions, including expert tax services and efficient processes, catering to your various insurance needs 24/7."
        keywords="Income tax in Houston,Income tax preparation in Houston,Tax office near Stafford,Tax office near 77036,Tax office near 77082,Tax office near 77099,Tax office near 77007,Tax office near 77479,Tax office near 77401,Tax office near 77489, Taxes, Financial, Financial Services, read, processes"
        url="https://www.aefinancialservicesllc.com"
        imageUrl={primaryImageUrl || defaultImageUrl}
      />
      <Header headerType="relative" />
      <Box
        sx={{
          width: '90%',
          margin: 3,
        }}
      >
        <Container maxWidth="lg">
          <Box sx={quoteStyles.card}>
            <Box sx={quoteStyles.content}>
              <InsuranceForm />
            </Box>
          </Box>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default Quote;
